export default "__VITE_ASSET__BflKhks0__"